module.exports = {"app.title":"Profil du Noyau","app.login":"Connectez","app.login.loggedIn":"Connecté en tant que: {name}","app.login.logout":"Connectez - Out","app.cancel":"Annuler","app.username":"Nom d'utilisateur","app.password":"Mot de passe","app.accounts.title":"Comptes","app.accounts.name":"Nom","app.accounts.accountType":"Type de compte","app.accounts.primaryContact":"Premier contact","entityList.search":"Rechercher","entityList.noResults":"Aucun résultat"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/lang/fr.json
// module id = 6449
// module chunks = 0